import { IDashboardResponse } from '../../../../model/scp/dashboard/dashboard-response';

export type DashboardState = {
    dashboardData: IDashboardResponse;
    selectedYear: number;
    startDate?: Date;
    endDate?: Date;
    loading: boolean;
};

export enum ACTION_TYPES {
    setDashboardData = 'setDashboardData',
    setSelectedYear = 'setSelectedYear',
    setStartDate = 'setStartDate',
    setEndDate = 'setEndDate',
    setLoading = 'setLoading',
}

export const DashboardReducer = (state: DashboardState, action: any): DashboardState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setDashboardData:
            return {
                ...state,
                dashboardData: payload,
            };
        case ACTION_TYPES.setSelectedYear:
            return {
                ...state,
                selectedYear: payload,
            };
        case ACTION_TYPES.setStartDate:
            return {
                ...state,
                startDate: payload,
            };
        case ACTION_TYPES.setEndDate:
            return {
                ...state,
                endDate: payload,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
